import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';

import { QueueIdEnum, TaskListModeEnum } from '../../inbox/shared/enums';
import { TaskListConfiguration } from '../../inbox/shared/models';
import { PushboxStatesEnum } from '../shared/enums';

@Component({
  selector: 'app-pushbox-task-list',
  templateUrl: './pushbox-task-list.component.html',
  styleUrls: ['./pushbox-task-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PushboxTaskListComponent {
  @Input() taskListConfiguration: TaskListConfiguration;

  taskListMode = TaskListModeEnum.Pushbox;

  constructor(@Inject('$state') private $state: any) {}

  goBack() {
    this.$state.go(PushboxStatesEnum.Pushbox, {
      queueId: QueueIdEnum.AssignedToYou,
    });
  }
}
